import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { typeofExpr } from '@angular/compiler/src/output/output_ast';
import { UtilService } from 'src/app/shared/services/util.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { ArchivoSolicitud } from 'src/app/models/archivoSolicitud.model';
import { UrlControl } from 'src/app/shared/models/generic.model';


@Component({
    selector: 'app-modal-aprobacion-ajuste-compensacion',
    templateUrl: './modal-aprobacion-ajuste-compensacion.component.html'
})
export class ModalAprobacionAjusteCompensacion implements OnInit {
    modalOptionsAprobar: any;
    modalOptionsRechazar: any;

    soportes: ArchivoSolicitud[];
    horas: number;
    observaciones: string;
    idSolicitud: number;
    maxHorasCompensacion: number;

    constructor(
        private activeModal: NgbActiveModal,
        private alertService: AlertService,
        private urlService: UrlService,
        private global: GlobalService,
        private spinner: NgxSpinnerService,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.modalOptionsAprobar = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_APROBAR_AJUSTE,
            'SI', 'NO', 'fas fa-save', false, false,
            'Aprobar',
            null, 'btn-secondary');
        this.modalOptionsRechazar = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_RECHAZAR_AJUSTE,
            'SI', 'NO', 'fas fa-save', false, false,
            'Rechazar',
            null, 'btn-secondary');
        this.cargarArchivosSoporte();
    }

    cargarArchivosSoporte() {
        this.spinner.show();
        const serviceProvider = 'listaArchivosSolicitud';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=solicitudAjusteIdSolicitud', this.idSolicitud.toString()]);
        
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.soportes = data;
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al realizar ajuste del funcionario a plan de compensación actual');
                }
            }
        );
    }

    descargarSoporte(soporte: ArchivoSolicitud) {
        this.spinner.show();
        const serviceProvider = 'descargarSoporte';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['idArchivo', soporte.idArchivo.toString()]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.spinner.hide();
                ConstantesService.descargarDocumento('application/pdf', data.nombre, data.archivo);
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al realizar ajuste del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite cerrar el modal cuando se da clic en el botón cerrar (x)
     * @function cerrar
     * @author dfranco@asesoftware.com
     */
    public cerrar() {
        this.activeModal.close();
    }

    /**
     * Método que permite iniciar el guardado de la solicitud de compensación
     * @function guardarSolicitud
     * @author dfranco@asesoftware.com
     * @param  event Objeto que contiene la decisión del usuario al mensaje de confirmación
     * @param  estado Estado que se asignará a la solicitud de ajuste
     */
    public guardarAjuste(event, estadoFinal) {
        if (event[0]) {
            let continuar = true;
            if (estadoFinal === DominiosService.ESTADO_AJUSTE_PLAN_COMPENSACION_APROBADO &&
                this.horas === undefined || 
                    (this.horas !== undefined && !this.utilService.validarCamposObligatorios(this.horas.toString()))) {
                continuar = false;
                this.alertService.generateAlertError(ConstantesService.MENSAJE_OBSERVACION_OBLIGATORIA_APROBACION_AJUSTE, '');
            } else if (this.horas !== undefined && this.horas > this.maxHorasCompensacion) {
                continuar = false;
                this.alertService.generateAlertError('Se pueden compensar máximo ' + this.maxHorasCompensacion + ' horas', '');
            } else if (estadoFinal === DominiosService.ESTADO_AJUSTE_PLAN_COMPENSACION_RECHAZADO &&
                !this.utilService.validarCamposObligatorios(this.observaciones)) {
                continuar = false;
                this.alertService.generateAlertError(ConstantesService.MENSAJE_OBSERVACION_OBLIGATORIA_RECHAZO_AJUSTE, '');
            }
            if (continuar) {
                const data: object = {
                    horas: estadoFinal === DominiosService.ESTADO_AJUSTE_PLAN_COMPENSACION_APROBADO ? this.horas : 0,
                    estado: estadoFinal,
                    observaciones: this.observaciones
                };
                this.activeModal.close(data);
            }
        }
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }
}